import { Injectable } from '@angular/core';
import { AnalyticService } from '@data/services/analytic.service';
import { ApplicationStateService } from './application-state.service';
import { first, lastValueFrom } from 'rxjs';
import { Platforms } from '@core/constants';
import { isHostedInWin } from '@core/win-bridge/win.utils';

@Injectable({
  providedIn: 'root',
})
export class WatchdogService {
  public deviceId: string;
  public platform: string;

  constructor(
    private analyticService: AnalyticService,
    private appStateService: ApplicationStateService,
  ) {
    this.platform = this.analyticService.getPlatformType();
  }

  public async initialize() {
    await this.sendAliveEvent();
    setInterval(() => this.sendAliveEvent(), 300000);
  }

  private async sendAliveEvent(): Promise<void> {
    const deviceConfiguration = await lastValueFrom(
      this.appStateService.deviceConfiguration$.pipe(first()),
    );

    this.deviceId = deviceConfiguration?.deviceId;
    const trainingCenterId = deviceConfiguration?.geminiSiteId;

    if (!this.deviceId || this.platform == Platforms.Web || !trainingCenterId) {
      return;
    }

    const hostInfo = isHostedInWin()
      ? await lastValueFrom(this.appStateService.hostInfo$.pipe(first()))
      : undefined;

    this.analyticService.trackAliveEvent({
      deviceId: this.deviceId,
      serialNumber: hostInfo?.DeviceSerialNumber,
      scannerSerialNumber: hostInfo?.ScannerSerialNumber,
      inventoryNumber: hostInfo?.DeviceName,
      winAppVersion: hostInfo?.AppVersion,
      trainingCenterId: trainingCenterId,
    });
  }
}
